"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Persons = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14"
}, props), _react.default.createElement("path", {
  d: "M9.888 7.996h1.14c2.747 0 4.973 2.372 4.972 5.297 0 .39-.297.707-.664.707H5.578c-.367 0-.664-.317-.664-.707v-.002c0-2.925 2.227-5.295 4.974-5.295zm.453-.71c-1.714 0-3.102-2.235-3.102-4.06C7.279 1.462 8.61.043 10.268 0c1.714-.044 3.136 1.4 3.177 3.225 0 1.825-1.39 4.06-3.104 4.06zM.616 13.5H.614c-.34 0-.615-.295-.614-.657.003-2.714 2.068-4.912 4.616-4.915H5.68c.433-.003.864.06 1.28.188-1.708 1.09-2.754 3.055-2.754 5.175 0 .07.005.14.016.21H.616zm4.427-6.236c-1.592 0-2.886-2.08-2.886-3.774-.002-.784.28-1.54.784-2.11C4.033.147 5.856.09 7.014 1.252a4.229 4.229 0 0 0-.484 1.976c.017.91.254 1.799.687 2.582-.527.836-1.306 1.454-2.174 1.454z",
  className: "fill"
}));

var _default = Persons;
exports.default = _default;